import { ICON_COLORS } from './icons.constants'
import { IconProps } from './icons.types'

export const SearchProspectsIcon = ({
  width = 20,
  height = 16,
  primaryColor = ICON_COLORS.PRIMARY.DEFAULT,
  secondaryColor = ICON_COLORS.SECONDARY.DEFAULT,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_6097_27205)'>
        <path
          d='M0 15.0719C0 11.9937 2.49375 9.5 5.57188 9.5H8.42813C8.62813 9.5 8.825 9.50937 9.02188 9.53125C9.00625 9.68437 9 9.84062 9 10C9 12.7625 11.2375 15 14 15C14 15.025 14 15.0469 14 15.0719C14 15.5844 13.5844 16 13.0719 16H0.928125C0.415625 16 0 15.5844 0 15.0719ZM11 4C11 5.06087 10.5786 6.07828 9.82843 6.82843C9.07828 7.57857 8.06087 8 7 8C5.93913 8 4.92172 7.57857 4.17157 6.82843C3.42143 6.07828 3 5.06087 3 4C3 2.93913 3.42143 1.92172 4.17157 1.17157C4.92172 0.421427 5.93913 0 7 0C8.06087 0 9.07828 0.421427 9.82843 1.17157C10.5786 1.92172 11 2.93913 11 4Z'
          fill={secondaryColor}
        />
        <path
          d='M16.5 10.0032C16.5 9.34013 16.2366 8.70425 15.7678 8.23541C15.2989 7.76657 14.663 7.50317 14 7.50317C13.337 7.50317 12.7011 7.76657 12.2322 8.23541C11.7634 8.70425 11.5 9.34013 11.5 10.0032C11.5 10.6662 11.7634 11.3021 12.2322 11.7709C12.7011 12.2398 13.337 12.5032 14 12.5032C14.663 12.5032 15.2989 12.2398 15.7678 11.7709C16.2366 11.3021 16.5 10.6662 16.5 10.0032ZM16.2469 13.3125C15.6063 13.75 14.8313 14.0032 14 14.0032C11.7906 14.0032 10 12.2125 10 10.0032C10 7.7938 11.7906 6.00317 14 6.00317C16.2094 6.00317 18 7.7938 18 10.0032C18 10.8375 17.7438 11.6094 17.3094 12.25L19.7812 14.725C20.075 15.0188 20.075 15.4938 19.7812 15.7844C19.4875 16.075 19.0125 16.0782 18.7219 15.7844L16.2469 13.3125Z'
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_6097_27205'>
          <rect
            width='20'
            height='16'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
